import {
  ReadReservationOccupancyInsightsState,
  OccupancyInsightsActionTypes,
  READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_REQUEST,
  READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_SUCCESS,
  READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_FAILURE
} from "store/reducers/occupancy-insights/readReservationOccupancyInsightsData/types";

const defaultState: ReadReservationOccupancyInsightsState = {
  isLoading: false,
  errorMessage: ""
};

export default function readReservationOccupancyInsightsData(state = defaultState, action: OccupancyInsightsActionTypes): ReadReservationOccupancyInsightsState {
  switch (action.type) {
    case READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_RESERVATION_OCCUPANCY_INSIGHTS_DATA_FAILURE:
      return {
        ...state,
        contents: undefined,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};